import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { formatWorkspaceDate } from "src/libs/portal/season/util/workspace-date";
import { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { activateListRow } from "src/libs/portal/season/util/list-row";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  height: auto;
  min-height: 0;
}

.dashboard-content {
  color: var(--ui-ink);
}

.dashboard-content .page-heading {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 12px;
}

.dashboard-content .page-title {
  display: flex;
  align-items: baseline;
  min-width: 0;
}

.dashboard-date {
  display: inline-block;
  white-space: nowrap;
}

.dashboard-content .page-title > p {
  min-width: 0;
}

.refresh-time {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.refresh-time.stale {
  color: var(--ui-warning);
}

.snapshot-status {
  color: var(--ui-muted);
  white-space: nowrap;
}

.section-title, .panel-heading h2 {
  margin: 0;
  color: var(--ui-ink);
  font-size: 17px;
  line-height: 1.4;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.section-title {
  margin-bottom: 12px;
}

.panel {
  min-width: 0;
  border: 0;
  border-radius: var(--ui-radius);
  background: var(--ui-paper);
  box-shadow: none;
}

.panel-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px;
}

.panel-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  color: var(--ui-accent);
  font-size: 14px;
  line-height: 1.5;
  font-weight: 550;
}

.panel-link:hover {
  color: var(--ui-accent-hover);
  text-decoration: underline;
  text-underline-offset: 4px;
}

.small-label {
  color: var(--ui-muted);
  font-size: 13px;
}

/* Four real status counts form the first scan line. Color identifies the domain. */
.status-overview {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.status-metric {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  min-width: 0;
  padding: 20px;
  border: 0;
  border-radius: var(--ui-radius);
  text-align: left;
  background: var(--metric-surface);
  color: var(--metric-ink);
  transition: background-color 160ms ease-out;
}

.source-metric {
  --metric-surface: var(--ui-accent);
  --metric-hover: var(--ui-accent-hover);
  --metric-ink: var(--ui-on-navy);
  --metric-secondary: var(--ui-selected);
}

.extraction-metric {
  --metric-surface:color-mix(in srgb,var(--ui-warning) 9%,var(--ui-paper));
  --metric-hover:color-mix(in srgb,var(--ui-warning) 15%,var(--ui-paper));
  --metric-ink:var(--ui-warning);
  --metric-secondary:var(--ui-warning);
}

.queue-metric {
  --metric-surface: var(--ui-soft);
  --metric-hover: var(--ui-hover);
  --metric-ink: var(--ui-ink);
  --metric-secondary: var(--ui-muted);
}

.extracted-metric {
  --metric-surface: var(--ui-soft);
  --metric-hover: var(--ui-hover);
  --metric-ink: var(--ui-ink);
  --metric-secondary: var(--ui-muted);
}

.status-metric > .metric-pending {
  font-size: 24px;
}

.status-metric .metric-label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  color: var(--metric-ink);
  font-size: 16px;
  line-height: 1.5;
  font-weight: 600;
}

.status-metric .metric-label i {
  color: inherit;
  font-size: 16px;
}

.status-metric > strong {
  color: inherit;
  font-size: 32px;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: -0.025em;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.status-metric small {
  margin-left: 6px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
}

.metric-caption {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: var(--metric-secondary);
  font-size: 13px;
  line-height: 1.5;
  font-weight: 450;
}

.metric-caption i {
  font-size: 10px;
}

.status-metric:hover {
  background: var(--metric-hover);
}

.status-metric:focus-visible {
  outline: 2px solid var(--metric-ink);
  outline-offset: -4px;
}

/* Review states stay comparable and separate from expert approval. */
.qa-status {
  margin-bottom: 16px;
}

.qa-status .panel-heading {
  padding-top: 12px;
  padding-bottom: 8px;
}

.qa-status-heading {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 16px;
  min-width: 0;
}

.qa-status-heading > span {
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.5;
}

.qa-status-counts {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin: 0;
  padding: 0 20px;
}

.qa-status-counts > div {
  min-width: 0;
  padding: 4px 20px 8px;
  border-right: 1px solid var(--ui-line);
}

.qa-status-counts > div:first-child {
  padding-left: 0;
}

.qa-status-counts > div:last-child {
  border: 0;
}

.qa-pending {
  --status-ink: #915b0a;
  --status-fill: #dba038;
}

.qa-held {
  --status-ink: #a34136;
  --status-fill: #c96d60;
}

.qa-reviewed {
  --status-ink: var(--ui-success);
  --status-fill: var(--ui-success);
}

.qa-excluded {
  --status-ink: #566276;
  --status-fill: #8491a4;
}

.qa-status-counts dt {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--status-ink);
  font-size: 14px;
  line-height: 1.5;
  font-weight: 550;
}

.status-dot {
  width: 8px;
  height: 8px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--status-fill);
}

.qa-status-counts dd {
  margin: 4px 0 0;
  color: var(--status-ink);
  font-size: 26px;
  line-height: 1.25;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.qa-status-counts small {
  margin-left: 6px;
  font-size: 13px;
  font-weight: 450;
}

.qa-status-bar {
  display: flex;
  height: 6px;
  margin: 8px 20px 0;
  border-radius: 4px;
  overflow: hidden;
  background: var(--ui-line);
}

.qa-status-bar > span {
  height: 100%;
  background: var(--status-fill);
}

.qa-status-footer {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px 16px;
  padding: 10px 20px 12px;
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.5;
}

.qa-status-footer strong {
  color: var(--ui-text);
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.quality-reference {
  display: flex;
  flex-wrap: wrap;
  align-items: start;
  gap: 0 24px;
  margin: -4px 0 16px;
}

.quality-total {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 44px;
  color: var(--ui-text);
  font-size: 14px;
  line-height: 1.5;
}

.quality-total > .fa-circle-exclamation, .quality-total strong {
  color: #85500a;
}

.quality-total strong {
  font-weight: 650;
  font-variant-numeric: tabular-nums;
}

.quality-total > .fa-chevron-right {
  color: var(--ui-muted);
  font-size: 10px;
}

.quality-total:hover {
  text-decoration: underline;
  text-underline-offset: 4px;
}

.quality-total:focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 3px;
}

.quality-reference .quality-breakdown {
  flex: 1;
  min-width: 0;
}

@media (max-width: 600px) {
  .quality-reference {
    display: block;
  }
  .status-metric .metric-label {
    flex-wrap: wrap;
  }
}
.quality-breakdown {
  margin: 0;
  color: var(--ui-text);
}

.quality-breakdown > summary, .stage-definitions > summary, .corpus-diagnostics > summary {
  cursor: pointer;
  min-height: 44px;
  align-content: center;
  color: var(--ui-text);
  font-size: 14px;
  line-height: 1.5;
  font-weight: 550;
}

.quality-breakdown-links {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 24px;
}

.quality-breakdown a {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 8px 0;
  color: var(--ui-text);
  font-size: 14px;
  line-height: 1.5;
}

.quality-breakdown a strong {
  margin-left: auto;
  color: var(--ui-ink);
  font-weight: 650;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.quality-breakdown a i {
  color: var(--ui-muted);
  font-size: 10px;
}

.quality-breakdown a:hover {
  color: var(--ui-accent);
  text-decoration: underline;
  text-underline-offset: 4px;
}

.quality-breakdown p {
  margin: 4px 0 0;
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.quality-breakdown p a {
  display: inline;
  min-height: 0;
  padding: 0;
  color: var(--ui-accent);
  font-size: inherit;
  text-decoration: underline;
  text-underline-offset: 3px;
}

/* Comparable stage counts stay visible; detailed provenance remains one disclosure away. */
.corpus-progress {
  margin: 0 0 12px;
  border-radius: var(--ui-radius);
  background: var(--ui-paper);
  overflow: hidden;
}

.corpus-heading-text {
  min-width: 0;
}

.corpus-total {
  margin: 4px 0 0;
  color: var(--ui-text);
  font-size: 14px;
  line-height: 1.5;
}

.corpus-total strong {
  color: var(--ui-ink);
  font-weight: 650;
  font-variant-numeric: tabular-nums;
}

.corpus-total > span {
  color: var(--ui-muted);
}

.stage-heading {
  display: grid;
  grid-template-columns: minmax(170px, 1.15fr) repeat(4, minmax(0, 1fr));
  gap: 16px;
  padding: 12px 20px;
  border-bottom: 1px solid var(--ui-line);
  background: var(--ui-paper);
  color: var(--ui-text);
  font-size: 14px;
  font-weight: 550;
}

.corpus-row {
  display: grid;
  grid-template-columns: minmax(170px, 1.15fr) repeat(4, minmax(0, 1fr));
  gap: 16px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--ui-line);
}

.corpus-name {
  min-width: 0;
}

.corpus-name h3 {
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  font-weight: 650;
  overflow-wrap: anywhere;
  letter-spacing: -0.015em;
}

.corpus-name a {
  color: var(--ui-ink);
  text-underline-offset: 4px;
}

.corpus-name a:hover {
  color: var(--ui-accent);
  text-decoration: underline;
}

.corpus-name p {
  margin: 4px 0 0;
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.5;
}

.corpus-row dl {
  grid-column: 2/-1;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin: 0;
}

.corpus-row dt {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
}

.corpus-row dd {
  margin: 0;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}

.corpus-row dd strong {
  display: block;
  color: var(--ui-ink);
  font-size: 17px;
  line-height: 1.5;
  font-weight: 650;
}

.corpus-row dd span {
  display: block;
  margin-top: 4px;
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.5;
}

.corpus-row dd .expert-count {
  color: var(--ui-text);
}

.corpus-issue {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  margin-top: 4px;
  color: var(--ui-accent);
  font-size: 13px;
  line-height: 1.5;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.stage-definitions > summary, .corpus-diagnostics > summary {
  padding: 10px 20px;
}

.corpus-diagnostics {
  border-bottom: 1px solid var(--ui-line);
}

.diagnostic-content {
  padding: 0 20px;
}

.corpus-diagnostic {
  padding: 12px 0 16px;
  border-top: 1px solid var(--ui-line);
}

.corpus-diagnostic h3 {
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 600;
}

.diagnostic-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px 24px;
  margin: 0;
}

.diagnostic-grid dt {
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.5;
  font-weight: 450;
}

.diagnostic-grid dd {
  margin: 4px 0 0;
  color: var(--ui-text);
  font-size: 14px;
  line-height: 1.5;
  font-variant-numeric: tabular-nums;
}

.stage-note {
  margin: 0;
  padding: 0 20px 16px;
  max-width: 85ch;
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.6;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(320px, 1fr);
  gap: 16px;
  align-items: start;
  height: auto;
}

.sources-panel, .collections-view {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}

.collection-list {
  min-height: 0;
  padding: 0;
  max-height: 460px;
  overflow-y: auto;
}

.collection-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 48px;
  padding: 10px 20px;
  border-bottom: 1px solid var(--ui-line);
  border-radius: 0;
  color: var(--ui-ink);
  text-align: left;
  transition: background-color 160ms ease-out;
}

.collection-row:last-child {
  border-bottom: 0;
}

.collection-row:hover {
  background: var(--ui-soft);
}

.collection-icon {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  color: #9a711c;
  font-size: 17px;
}

.collection-icon.public {
  color: var(--ui-muted);
}

.collection-name {
  display: block;
  min-width: 0;
  color: var(--ui-ink);
  font-size: 14px;
  font-weight: 550;
  overflow-wrap: anywhere;
  line-height: 1.6;
}

.collection-count {
  margin-left: auto;
  font-size: 14px;
  font-weight: 650;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.collection-count small {
  margin-left: 6px;
  font-size: 13px;
  color: var(--ui-muted);
  font-weight: 450;
}

.collection-arrow {
  margin-left: 3px;
  color: var(--ui-muted);
  font-size: 10px;
}

.collection-caption {
  border-top: 1px solid var(--ui-line);
  padding: 12px 20px;
  font-size: 13px;
  line-height: 1.5;
  color: var(--ui-muted);
  background: var(--ui-soft);
}

.activity-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.extraction-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  border-bottom: 1px solid var(--ui-line);
  color: var(--ui-ink);
}

.extraction-row:last-of-type {
  border-bottom: 0;
}

.extraction-row:hover {
  background: var(--ui-soft);
}

.extraction-row > span {
  flex: 1;
  min-width: 0;
}

.extraction-row strong {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 550;
}

.extraction-row small {
  display: block;
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.5;
  color: var(--ui-muted);
}

.extraction-file-icon {
  flex-shrink: 0;
  font-size: 19px;
  color: var(--ui-danger);
}

.extraction-row > .fa-chevron-right {
  font-size: 10px;
  color: var(--ui-muted);
}

.dashboard-secondary {
  display: grid;
  gap: 12px;
  margin-top: 16px;
}

.history-entry {
  min-height: 44px;
  justify-self: start;
}

.dashboard-details {
  min-width: 0;
}

.dashboard-details summary {
  cursor: pointer;
  min-height: 44px;
  padding: 12px 20px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--ui-text);
  font-weight: 600;
}

.dashboard-details summary .small-label {
  float: right;
  font-size: 13px;
  font-weight: 450;
  margin-left: 12px;
}

.qa-panel[open] {
  padding-bottom: 16px;
}

.stacked-bar {
  display: flex;
  height: 7px;
  margin: 6px 20px 12px;
  overflow: hidden;
  border-radius: 4px;
  background: var(--ui-soft);
}

.stacked-bar > span {
  display: block;
  height: 100%;
}

.bar-pending {
  background: var(--ui-accent);
}

.bar-revision {
  background: #b98536;
}

.bar-approved {
  background: var(--ui-success);
}

.bar-rejected {
  background: #b65760;
}

.qa-legend {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px 20px;
  margin: 0;
  padding: 0 20px;
  list-style: none;
}

.qa-legend li {
  padding: 6px 0;
  gap: 8px;
  color: var(--ui-text);
  font-size: 14px;
}

.qa-legend strong {
  color: var(--ui-ink);
  font-weight: 600;
}

.qa-caution {
  margin: 12px 20px 0;
  padding: 12px;
  color: var(--ui-warning);
  background: #fff5e7;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.6;
}

.qa-caution i {
  margin-top: 3px;
}

.history-workspace .history-list {
  max-height: none;
  overflow: visible;
}

.history-workspace .history-filters {
  max-width: 760px;
}

.history-note, .history-error {
  margin: 0;
  padding: 6px 20px 12px;
  font-size: 13px;
  line-height: 1.6;
  color: var(--ui-muted);
}

.history-note a {
  color: var(--ui-accent);
  text-decoration: underline;
}

.history-error {
  color: var(--ui-danger);
}

.history-filters {
  display: flex;
  align-items: end;
  gap: 8px;
  padding: 0 20px 12px;
}

.history-filters label {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: 4px;
  font-size: 13px;
  color: var(--ui-muted);
}

.history-filters select {
  width: 100%;
  min-width: 0;
  height: 44px;
  padding: 8px 24px 8px 8px;
  border: 1px solid var(--ui-line-strong, var(--ui-line));
  border-radius: 6px;
  background: var(--ui-paper);
  color: var(--ui-text);
  font-size: 14px;
}

.history-list {
  max-height: 460px;
  overflow-y: auto;
}

.job {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 20px;
  border-top: 1px solid var(--ui-line);
}

.job-main {
  flex: 1;
  min-width: 0;
}

.job-name {
  display: block;
  color: var(--ui-ink);
  overflow-wrap: anywhere;
  font-size: 14px;
  font-weight: 550;
  line-height: 1.5;
}

a.job-name {
  color: var(--ui-accent);
  text-underline-offset: 3px;
}

a.job-name:hover {
  text-decoration: underline;
}

.job-name i {
  margin-left: 6px;
  font-size: 10px;
}

.job-meta, .job-note {
  display: block;
  margin-top: 4px;
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.5;
}

.history-pagination {
  display: flex;
  align-items: center;
  gap: 8px;
  border-top: 1px solid var(--ui-line);
  padding: 12px 20px;
  font-size: 13px;
  color: var(--ui-muted);
  font-variant-numeric: tabular-nums;
}

.history-pagination > span:first-child {
  margin-right: auto;
}

.history-pagination .button {
  min-width: 44px;
  width: 44px;
  height: 44px;
  padding: 0;
}

.status-badge {
  font-size: 13px;
}

.status-badge.approved {
  color: var(--ui-success);
}

.stage-text {
  --stage-ink: var(--ui-accent);
  --stage-surface: var(--ui-selected);
}

.stage-knowledge {
  --stage-ink: var(--ui-text);
  --stage-surface: var(--ui-soft);
}

.stage-review {
  --stage-ink: var(--ui-success);
  --stage-surface: var(--ui-success-soft);
}

.stage-sync {
  --stage-ink: var(--ui-accent);
  --stage-surface: var(--ui-selected);
}

.stage-heading > span {
  padding: 8px 10px;
  border-radius: 6px;
}

.stage-heading > span:first-child {
  padding-left: 0;
}

.stage-heading > [class^=stage-] {
  color: var(--stage-ink);
  background: var(--stage-surface);
}

.corpus-row dd > strong {
  color: var(--stage-ink, var(--ui-ink));
}

.corpus-row dt {
  color: var(--stage-ink, var(--ui-text));
}

.corpus-row dd > .corpus-coverage {
  display: block;
  height: 4px;
  max-width: 160px;
  margin: 6px 0;
  overflow: hidden;
  border-radius: 3px;
  background: var(--ui-line);
}

.corpus-row dd > .corpus-coverage > span {
  display: block;
  height: 100%;
  margin: 0;
  background: var(--ui-accent);
}

.corpus-issue {
  color: #85500a;
}

.extraction-row:focus-visible, .collection-row:focus-visible, summary:focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: -3px;
}

@media (max-width: 1200px) {
  .status-metric {
    padding: 16px;
  }
  .status-metric > strong {
    font-size: 28px;
  }
  .metric-label {
    font-size: 15px;
  }
  .stage-heading {
    display: none;
  }
  .corpus-row {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .corpus-row dl {
    grid-column: auto;
  }
  .corpus-row dt {
    position: static;
    width: auto;
    height: auto;
    clip: auto;
    margin-bottom: 6px;
    font-size: 14px;
    font-weight: 550;
  }
}
@media (max-width: 960px) {
  .dashboard-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .collection-list {
    max-height: none;
  }
  .diagnostic-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .qa-status-heading {
    display: block;
  }
  .qa-status-heading > span {
    display: block;
    margin-top: 4px;
  }
}
@media (max-width: 900px) {
  .status-overview {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 600px) {
  .dashboard-content .page-title {
    display: block;
  }
  .dashboard-content .page-title > p {
    margin-top: 6px;
  }
  .dashboard-content .page-heading > .button {
    width: 44px;
    height: 44px;
    padding: 0;
    font-size: 0;
  }
  .dashboard-content .page-heading > .button i {
    font-size: 15px;
  }
  .panel-heading h2 {
    font-size: 16px;
  }
  .status-overview {
    gap: 10px;
    margin-bottom: 12px;
  }
  .status-metric {
    gap: 8px;
    padding: 16px;
  }
  .status-metric > strong {
    font-size: 26px;
  }
  .metric-label {
    gap: 6px;
    font-size: 14px;
  }
  .metric-label i {
    font-size: 14px;
  }
  .metric-caption {
    font-size: 13px;
  }
  .metric-caption i {
    display: none;
  }
  .qa-status {
    margin-bottom: 12px;
  }
  .panel-heading {
    padding: 12px 16px;
    gap: 12px;
  }
  .panel-link {
    font-size: 13px;
  }
  .qa-status .panel-heading {
    align-items: start;
    flex-wrap: wrap;
    gap: 0;
  }
  .qa-status .panel-link {
    min-height: 36px;
  }
  .qa-status-counts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding: 0 16px;
    gap: 12px 0;
  }
  .qa-status-counts > div {
    padding: 0 12px 4px;
  }
  .qa-status-counts > div:nth-child(odd) {
    padding-left: 0;
  }
  .qa-status-counts > div:nth-child(even) {
    border: 0;
  }
  .qa-status-counts dd {
    font-size: 24px;
  }
  .qa-status-bar {
    margin: 12px 16px 0;
  }
  .qa-status-footer {
    padding: 10px 16px 12px;
  }
  .corpus-progress .panel-heading {
    align-items: start;
    flex-wrap: wrap;
    gap: 4px;
  }
  .corpus-progress .panel-link {
    min-height: 36px;
  }
  .corpus-total {
    font-size: 13px;
  }
  .corpus-row {
    padding: 16px;
    gap: 16px;
  }
  .corpus-name h3 {
    font-size: 16px;
  }
  .corpus-row dl {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px 12px;
  }
  .corpus-row dd strong {
    font-size: 16px;
  }
  .corpus-issue {
    min-height: 44px;
  }
  .stage-definitions > summary, .corpus-diagnostics > summary {
    padding: 10px 16px;
  }
  .diagnostic-content {
    padding: 0 16px;
  }
  .diagnostic-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .stage-note {
    padding: 0 16px 16px;
  }
  .quality-breakdown-links {
    display: grid;
    gap: 0;
  }
  .quality-breakdown a {
    border-bottom: 1px solid var(--ui-line);
  }
  .collection-row, .extraction-row {
    padding: 12px 16px;
    gap: 10px;
  }
  .collection-caption {
    padding: 12px 16px;
  }
  .dashboard-details summary {
    padding: 12px 16px;
  }
  .dashboard-details summary .small-label {
    float: none;
    display: block;
    margin: 4px 0 0 16px;
  }
  .history-note, .history-error {
    padding-left: 16px;
    padding-right: 16px;
  }
  .history-filters {
    padding: 0 16px 12px;
  }
  .job {
    padding: 12px 16px;
  }
  .history-pagination {
    padding: 12px 16px;
  }
  .qa-legend {
    gap: 4px 16px;
    padding: 0 16px;
  }
}
@media (max-width: 360px) {
  .status-metric {
    padding: 12px;
  }
  .status-metric > strong {
    font-size: 23px;
  }
  .status-metric small {
    margin-left: 4px;
    font-size: 13px;
  }
}
/* Processing history compares targets, types, status, and time in aligned columns. */
.history-workspace .history-toolbar {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px;
}

.history-workspace .history-filters {
  flex: 1;
  max-width: 620px;
  padding: 0;
  gap: 12px;
}

.history-workspace .history-filters label {
  color: var(--ui-text);
  gap: 6px;
}

.history-workspace .history-filters select {
  appearance: auto;
  -webkit-appearance: auto;
  height: 40px;
  border-color: var(--ui-control);
  padding-right: 28px;
}

.history-total {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  font-size: 13px;
  color: var(--ui-muted);
  font-variant-numeric: tabular-nums;
}

.history-total strong {
  font-size: 18px;
  font-weight: 700;
  color: var(--ui-ink);
}

.history-workspace .history-columns, .history-workspace .job {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 150px 100px 180px;
  align-items: center;
  gap: 16px;
}

.history-columns {
  padding: 10px 20px;
  border-top: 1px solid var(--ui-line);
  background: var(--ui-soft);
  color: var(--ui-muted);
  font-size: 13px;
}

.history-workspace .job {
  padding: 14px 20px;
  min-height: 66px;
}

.history-workspace .job-name {
  font-size: 15px;
  line-height: 1.6;
  font-weight: 600;
}

.history-workspace .job-name i {
  font-size: 10px;
  color: var(--ui-muted);
}

.history-workspace .job-type {
  font-size: 13px;
  color: var(--ui-text);
  overflow-wrap: anywhere;
}

.history-workspace .job-start {
  font-size: 13px;
  line-height: 1.6;
  color: var(--ui-muted);
  font-variant-numeric: tabular-nums;
}

.history-workspace .status-badge {
  justify-self: start;
  white-space: nowrap;
  font-size: 13px;
  padding: 3px 8px;
  border-radius: 5px;
  color: var(--ui-muted);
  background: var(--ui-soft);
}

.history-workspace .status-badge[data-status=SUCCESS] {
  color: var(--ui-success);
  background: var(--ui-success-soft);
}

.history-workspace .status-badge[data-status=RUNNING], .history-workspace .status-badge[data-status=CANCELLING], .history-workspace .status-badge[data-status=PAUSING] {
  color: var(--ui-accent);
  background: var(--ui-selected);
}

.history-workspace .status-badge[data-status=FAILED] {
  color: var(--ui-danger);
  background: #fff3f4;
}

.history-workspace .status-badge[data-status=NEEDS_ATTENTION], .history-workspace .status-badge[data-status=PAUSED] {
  color: var(--ui-warning);
  background: #fff4e3;
}

.history-mobile-label {
  display: none;
}

.history-help {
  padding: 0 20px 12px;
  border-top: 1px solid var(--ui-line);
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.7;
}

.history-help summary {
  width: fit-content;
  min-height: 40px;
  padding: 10px 0;
  cursor: pointer;
  font-weight: 550;
}

.history-help p {
  margin: 2px 0 8px;
}

@media (max-width: 1100px) {
  .history-workspace .history-columns, .history-workspace .job {
    grid-template-columns: minmax(0, 1fr) 120px 80px 164px;
    gap: 12px;
  }
}
@media (max-width: 760px) {
  .history-workspace .history-toolbar {
    align-items: stretch;
    flex-wrap: wrap;
    padding: 14px 16px;
    gap: 12px;
  }
  .history-workspace .history-filters {
    flex-basis: 100%;
    max-width: none;
    gap: 8px;
  }
  .history-workspace .history-filters select {
    height: 44px;
    font-size: 14px;
  }
  .history-total {
    flex-direction: row;
    align-items: baseline;
    gap: 8px;
  }
  .history-total strong {
    font-size: 16px;
  }
  .history-workspace .history-columns {
    display: none;
  }
  .history-workspace .job {
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 6px 12px;
    padding: 14px 16px;
  }
  .history-workspace .job-main {
    grid-column: 1/-1;
    grid-row: 1;
  }
  .history-workspace .job-name {
    font-size: 15px;
  }
  .history-workspace .job-type {
    grid-column: 1;
    grid-row: 2;
  }
  .history-workspace .status-badge {
    grid-column: 2;
    grid-row: 2;
    justify-self: end;
  }
  .history-workspace .job-start {
    grid-column: 1/-1;
    grid-row: 3;
  }
  .history-mobile-label {
    display: inline;
  }
  .history-help {
    padding-inline: 16px;
  }
  .history-help summary {
    min-height: 44px;
  }
}
/* Keep the row affordance beside the name and compact mobile metadata. */
.history-workspace a.job-name {
  position: relative;
  padding-right: 18px;
}

.history-workspace .job-name i {
  position: absolute;
  top: 6px;
  right: 0;
  margin: 0;
}

.history-workspace .job-main {
  grid-column: 1;
  grid-row: 1;
}

.history-workspace .job-meta {
  display: contents;
}

.history-workspace .job-type {
  grid-column: 2;
  grid-row: 1;
}

.history-workspace .status-badge {
  grid-column: 3;
  grid-row: 1;
}

.history-workspace .job-start {
  grid-column: 4;
  grid-row: 1;
}

@media (max-width: 760px) {
  .history-workspace .job {
    align-items: start;
  }
  .history-workspace .job-main {
    grid-column: 1/-1;
  }
  .history-workspace .job-meta {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 2px 8px;
    grid-column: 1;
    grid-row: 2;
    margin: 0;
    min-width: 0;
  }
  .history-workspace .job-start {
    white-space: nowrap;
  }
  .history-workspace .status-badge {
    grid-column: 2;
    grid-row: 2;
  }
}
.history-workspace a.job-name {
  color: var(--ui-ink);
}

.history-workspace .job:hover a.job-name, .history-workspace a.job-name:focus-visible {
  color: var(--ui-accent);
}

/* Research desk: a single live status strip and grounded document work surfaces. */
.dashboard-content {
  --ui-amber:var(--ui-warning);
}

.dashboard-content > .page-heading {
  margin-bottom: 22px;
}

.dashboard-content > .page-heading .page-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.dashboard-content .status-overview {
  display: grid;
  grid-template-columns: 1.25fr repeat(3, minmax(0, 1fr));
  gap: 0;
  margin: 0 0 20px;
  background: var(--ui-paper);
  border: 1px solid var(--ui-line);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: none;
}

.dashboard-content .status-metric {
  display: flex;
  gap: 6px;
  min-width: 0;
  min-height: 98px;
  padding: 15px 18px;
  border: 0;
  border-radius: 0;
  border-right: 1px solid var(--ui-line);
  background: transparent;
  color: var(--ui-text);
  text-align: left;
}

.dashboard-content .status-metric:last-child {
  border-right: 0;
}

.dashboard-content .status-metric:hover {
  background: var(--ui-hover);
  box-shadow: none;
  transform: none;
}

.dashboard-content .status-metric:focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: -5px;
}

.dashboard-content .status-metric .metric-label {
  gap: 8px;
  font-size: 13px;
  font-weight: 550;
  color: var(--ui-muted);
}

.dashboard-content .status-metric .metric-label i {
  width: 18px;
  background: transparent;
  color: var(--ui-accent);
  font-size: 14px;
}

.dashboard-content .status-metric strong {
  color: var(--ui-ink);
  font-size: 24px;
  line-height: 1.15;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.dashboard-content .status-metric strong small {
  font-size: 12px;
  font-weight: 450;
  margin-left: 5px;
  color: var(--ui-muted);
}

.dashboard-content .status-metric .metric-caption {
  font-size: 12px;
  color: var(--ui-muted);
}

.dashboard-content .status-metric.extracted-metric {
  background: var(--ui-soft);
}

.dashboard-content .status-metric.extracted-metric .metric-label i {
  color: var(--ui-accent);
  background: transparent;
}

.dashboard-content .status-metric.extracted-metric strong {
  font-size: 28px;
  color: var(--ui-ink);
}

.dashboard-content .status-metric.extracted-metric .metric-pending {
  font-size: 23px;
}

.dashboard-content .status-metric.extraction-metric .metric-label i {
  color: var(--ui-warning);
  background: transparent;
}

.dashboard-content .status-metric.queue-metric .metric-label i {
  color: var(--ui-accent);
  background: transparent;
}

.dashboard-content .status-metric[aria-pressed=true] {
  background: var(--ui-selected);
}

.dashboard-content .dashboard-main-grid {
  display: grid;
  grid-template-columns: minmax(0, 2.45fr) minmax(268px, 1fr);
  align-items: start;
  gap: 20px;
  margin-bottom: 20px;
}

.dashboard-content :is(.corpus-progress, .qa-status, .sources-panel, .history-panel) {
  margin: 0;
  min-width: 0;
  background: var(--ui-paper);
  border: 1px solid var(--ui-line);
  border-radius: 14px;
  box-shadow: none;
  overflow: hidden;
}

.dashboard-content .dashboard-main-grid .panel-heading {
  padding: 17px 20px;
  min-height: 72px;
  border-bottom: 1px solid var(--ui-line);
  gap: 12px;
}

.dashboard-content .dashboard-main-grid h2 {
  color: var(--ui-ink);
  font-size: 16px;
  font-weight: 650;
}

.dashboard-content .corpus-total {
  margin-top: 4px;
  font-size: 13px;
  color: var(--ui-muted);
}

.dashboard-content .corpus-total strong {
  color: var(--ui-ink);
}

.dashboard-content .stage-heading {
  grid-template-columns: minmax(104px, 1.15fr) repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin: 0;
  padding: 10px 20px;
  border: 0;
  background: var(--ui-soft);
}

.dashboard-content .stage-heading span {
  padding: 0;
  background: none;
  border: 0;
  border-radius: 0;
  color: var(--ui-muted);
  font-size: 13px;
}

.dashboard-content .corpus-row {
  grid-template-columns: minmax(104px, 1.15fr) repeat(4, minmax(0, 1fr));
  gap: 12px;
  padding: 18px 20px;
  border-color: var(--ui-line);
}

.dashboard-content .corpus-name h3 {
  font-size: 14px;
  font-weight: 650;
  color: var(--ui-ink);
}

.dashboard-content .corpus-name p {
  font-size: 13px;
  color: var(--ui-muted);
  margin-top: 5px;
}

.dashboard-content .corpus-row dl {
  grid-column: 2/-1;
  gap: 12px;
}

.dashboard-content .corpus-row dl strong {
  font-size: 15px;
  font-weight: 650;
  line-height: 1.65;
}

.dashboard-content .corpus-row dl dd > span {
  font-size: 13px;
  color: var(--ui-muted);
  line-height: 1.65;
}

.dashboard-content .corpus-coverage {
  height: 4px;
  margin: 8px 0 6px;
  background: var(--ui-line);
  border-radius: 3px;
}

.dashboard-content :is(.corpus-diagnostics, .stage-definitions) {
  padding: 0 20px;
  margin: 0;
  border-top: 1px solid var(--ui-line);
}

.dashboard-content :is(.corpus-diagnostics, .stage-definitions) > summary {
  min-height: 42px;
  padding: 11px 0;
  color: var(--ui-text);
  font-size: 13px;
}

.dashboard-content .diagnostic-content {
  padding: 0;
}

.dashboard-content .stage-note {
  padding: 0 0 16px;
}

.dashboard-content .qa-status {
  background: var(--ui-soft);
}

.dashboard-content .qa-status .panel-heading {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.dashboard-content .qa-status-heading {
  display: block;
}

.dashboard-content .qa-status-heading > span {
  display: block;
  font-size: 13px;
  color: var(--ui-muted);
  margin-top: 5px;
}

.dashboard-content .qa-status .panel-link {
  font-size: 13px;
  min-height: 28px;
  margin: 0;
}

.dashboard-content .qa-status-counts {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 20px;
  margin: 0;
  padding: 20px;
}

.dashboard-content .qa-status-counts > div {
  padding: 0;
  border: 0;
}

.dashboard-content .qa-status-counts dt {
  font-size: 13px;
  margin-bottom: 5px;
}

.dashboard-content .qa-status-counts dd {
  font-size: 27px;
  font-weight: 700;
  line-height: 1.2;
}

.dashboard-content .qa-status-counts dd small {
  font-size: 13px;
  font-weight: 450;
}

.dashboard-content .qa-status-bar {
  height: 5px;
  margin: 0 20px;
  border-radius: 3px;
}

.dashboard-content .qa-status-footer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 14px 20px 18px;
  font-size: 13px;
}

.dashboard-content .quality-reference {
  margin: 0 0 20px;
  padding: 10px 16px;
  border: 1px solid #e4d8bd;
  border-radius: 12px;
  background: #faf7ef;
  gap: 0 24px;
}

.dashboard-content .quality-total {
  font-size: 13px;
  min-height: 38px;
}

.dashboard-content .quality-breakdown > summary {
  font-size: 13px;
  min-height: 38px;
}

.dashboard-content .dashboard-grid {
  grid-template-columns: minmax(0, 1fr) minmax(260px, 0.7fr);
  gap: 20px;
  margin-bottom: 20px;
}

.dashboard-content .sources-panel .panel-heading {
  padding: 16px 20px;
  border-bottom: 1px solid var(--ui-line);
}

.dashboard-content .collection-row {
  min-height: 58px;
  padding: 12px 20px;
  border-color: var(--ui-line);
}

.dashboard-content .collection-icon {
  border: 0;
  background: var(--ui-soft);
  color: var(--ui-muted);
  border-radius: 8px;
}

.dashboard-content .collection-icon.public {
  background: var(--ui-soft);
  color: var(--ui-muted);
}

.dashboard-content .history-panel .panel-heading {
  padding: 18px 20px;
}

.dashboard-content .history-toolbar {
  padding: 16px 20px;
  background: var(--ui-soft);
  border-top: 1px solid var(--ui-line);
}

.dashboard-content .history-workspace .history-filters {
  padding: 0;
  background: transparent;
}

.dashboard-content .history-columns {
  padding-block: 11px;
  background: var(--ui-soft);
  font-size: 13px;
  color: var(--ui-muted);
}

.dashboard-content .history-list .job {
  padding-block: 15px;
  border-color: var(--ui-line);
}

.dashboard-content .history-list .job:hover {
  background: var(--ui-selected);
}

.dashboard-content .history-list .job-name {
  font-size: 14px;
  font-weight: 550;
}

.dashboard-content .dashboard-details {
  border-radius: 12px;
  background: var(--ui-paper);
  box-shadow: none;
  overflow: hidden;
}

.deliverable-status {
  margin: 0 0 20px;
  border: 0;
  border-radius: 14px;
  box-shadow: none;
  background: var(--ui-paper);
  overflow: hidden;
}

.deliverable-status .panel-heading {
  padding: 16px 20px;
  gap: 6px 18px;
  flex-wrap: wrap;
  border-bottom: 1px solid var(--ui-line);
}

.deliverable-status .panel-heading p {
  font-size: 13px;
  color: var(--ui-muted);
  margin: 0;
}

.deliverable-row {
  display: grid;
  grid-template-columns: minmax(150px, 1.1fr) minmax(150px, 1fr) minmax(160px, 1.2fr) auto;
  gap: 12px 20px;
  align-items: center;
  padding: 14px 20px;
  border-bottom: 1px solid var(--ui-line);
}

.deliverable-title h3 {
  margin: 0 0 4px;
  color: var(--ui-ink);
  font-size: 14px;
  font-weight: 650;
  line-height: 1.5;
}

.deliverable-row strong {
  font-size: 14px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.deliverable-title > span, .deliverable-current > span, .deliverable-artifact > span, .deliverable-artifact time {
  display: block;
  font-size: 13px;
  color: var(--ui-muted);
  line-height: 1.65;
}

.deliverable-current > span.needs-check {
  color: var(--ui-warning);
}

.deliverable-artifact {
  min-width: 0;
}

.deliverable-artifact .artifact-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.deliverable-link {
  white-space: nowrap;
  font-size: 13px;
}

.deliverable-definitions {
  padding: 10px 20px;
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.7;
}

.deliverable-definitions summary {
  width: fit-content;
  cursor: pointer;
  min-height: 28px;
  color: var(--ui-text);
}

.deliverable-definitions p {
  margin: 8px 0 0;
}

.history-workspace .history-toolbar {
  align-items: flex-start;
}

.history-workspace .history-filters {
  display: grid;
  grid-template-columns: minmax(180px, 1.4fr) minmax(130px, 1fr) minmax(130px, 1fr);
  max-width: none;
  align-items: end;
}

.history-workspace .history-filters input {
  width: 100%;
  min-width: 0;
  height: 38px;
  padding: 8px 10px;
  border: 1px solid var(--ui-control);
  border-radius: 9px;
  background: var(--ui-paper);
  color: var(--ui-text);
  font: inherit;
  font-size: 14px;
}

.history-workspace .history-dates {
  grid-column: 1/3;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;
}

.history-workspace .history-dates legend {
  padding: 0 0 6px;
  font-size: 13px;
  color: var(--ui-text);
}

.history-workspace .history-dates input {
  flex: 1;
  min-width: 0;
}

.history-filter-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 40px;
}

.history-filter-actions .panel-link:disabled {
  opacity: 0.5;
  cursor: default;
}

.history-workspace .history-total {
  padding-top: 23px;
}

@media (max-width: 1250px) {
  .dashboard-content .dashboard-main-grid {
    grid-template-columns: 1fr;
  }
  .dashboard-content .qa-status .panel-heading {
    flex-direction: row;
    align-items: center;
  }
  .dashboard-content .qa-status .panel-link {
    min-height: 36px;
  }
  .dashboard-content .qa-status-counts {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .dashboard-content .qa-status-footer {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
@media (max-width: 1200px) {
  .dashboard-content .corpus-row {
    grid-template-columns: 1fr;
  }
  .dashboard-content .corpus-row dl {
    grid-column: 1;
  }
  .dashboard-content .stage-heading {
    display: none;
  }
  .dashboard-content .corpus-row dl dt {
    display: block;
  }
}
@media (max-width: 1100px) {
  .deliverable-row {
    grid-template-columns: minmax(150px, 1fr) minmax(160px, 1fr) minmax(160px, 1fr);
    gap: 10px 16px;
  }
  .deliverable-link {
    grid-column: 3;
    justify-self: start;
  }
  .dashboard-content .dashboard-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 700px) {
  .dashboard-content > .page-heading {
    margin-bottom: 16px;
  }
  .dashboard-content .status-overview {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0;
    margin: 0 0 20px;
    background: var(--ui-paper);
    border: 1px solid var(--ui-line);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: none;
  }
  .dashboard-content .status-metric {
    min-height: 98px;
    padding: 14px;
    gap: 6px;
  }
  .dashboard-content .status-metric:nth-child(2n) {
    border-right: 0;
  }
  .dashboard-content .status-metric:nth-child(-n+2) {
    border-bottom: 1px solid var(--ui-line);
  }
  .dashboard-content .status-metric strong {
    color: var(--ui-ink);
    font-size: 24px;
    line-height: 1.15;
    font-weight: 700;
    letter-spacing: -0.02em;
  }
  .dashboard-content .status-metric.extracted-metric strong {
    font-size: 28px;
  }
  .dashboard-content .status-metric .metric-label {
    gap: 8px;
    font-size: 13px;
    font-weight: 550;
    color: var(--ui-muted);
  }
  .dashboard-content .status-metric .metric-label i {
    width: 18px;
    background: transparent;
    color: var(--ui-accent);
    font-size: 14px;
  }
  .dashboard-content .dashboard-main-grid {
    gap: 16px;
  }
  .dashboard-content .corpus-row {
    padding: 16px;
    gap: 14px;
    grid-template-columns: 1fr;
  }
  .dashboard-content .corpus-row dl {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }
  .dashboard-content .corpus-row dl dt {
    font-size: 13px;
  }
  .dashboard-content .corpus-row dl strong {
    font-size: 16px;
  }
  .dashboard-content .qa-status .panel-heading {
    padding: 16px;
    align-items: flex-start;
  }
  .dashboard-content .qa-status-counts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding: 16px;
    gap: 18px;
  }
  .dashboard-content .qa-status-footer {
    flex-direction: column;
    padding: 14px 16px 16px;
  }
  .dashboard-content .quality-reference {
    padding: 8px 14px;
  }
  .dashboard-content .history-panel .panel-heading {
    padding: 16px;
  }
  .deliverable-status .panel-heading, .deliverable-row {
    padding: 16px;
  }
  .deliverable-row {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
  .deliverable-title, .deliverable-link {
    grid-column: 1/-1;
  }
  .deliverable-artifact .artifact-name {
    white-space: normal;
    overflow-wrap: anywhere;
  }
  .deliverable-definitions {
    padding: 10px 16px;
  }
  .deliverable-definitions summary {
    min-height: 44px;
    align-content: center;
  }
  .history-workspace .history-filters {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .history-workspace .history-target, .history-workspace .history-dates, .history-workspace .history-filter-actions {
    grid-column: 1/-1;
  }
  .history-workspace .history-total {
    padding-top: 0;
  }
  .history-workspace .history-filters input {
    min-height: 44px;
  }
}
@media (max-width: 360px) {
  .dashboard-content .status-metric {
    display: flex;
    gap: 6px;
    min-width: 0;
    min-height: 92px;
    padding: 15px 18px;
    border: 0;
    border-radius: 0;
    border-right: 1px solid var(--ui-line);
    background: transparent;
    color: var(--ui-text);
    text-align: left;
  }
  .dashboard-content .status-metric strong, .dashboard-content .status-metric.extracted-metric strong {
    font-size: 24px;
    color: var(--ui-ink);
  }
}
.dashboard-launchpad {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
  gap: 20px;
  align-items: start;
  margin-bottom: 20px;
}

.dashboard-content :is(.priority-work, .recent-extractions) {
  min-width: 0;
  border: 1px solid var(--ui-line);
  border-radius: 12px;
  background: var(--ui-paper);
  overflow: hidden;
  box-shadow: none;
}

.dashboard-content :is(.priority-work, .recent-extractions) .panel-heading {
  display: flex;
  align-items: center;
  min-height: 58px;
  padding: 15px 18px;
  border-bottom: 1px solid var(--ui-line);
}

.dashboard-content :is(.priority-work, .recent-extractions) .panel-heading h2 {
  font-size: 16px;
  color: var(--ui-ink);
}

.dashboard-content .priority-row {
  display: flex;
  align-items: center;
  gap: 13px;
  min-height: 88px;
  padding: 17px 18px;
  border-bottom: 1px solid var(--ui-line);
  color: var(--ui-text);
}

.dashboard-content .priority-row:last-child {
  border-bottom: 0;
}

.dashboard-content .priority-row:hover {
  background: var(--ui-hover);
}

.dashboard-content .priority-symbol {
  display: grid;
  place-items: center;
  flex: none;
  width: 26px;
  color: var(--ui-accent);
  font-size: 19px;
}

.dashboard-content .priority-symbol.warning {
  color: var(--ui-warning);
}

.dashboard-content .priority-copy {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
  flex: 1;
}

.dashboard-content .priority-copy > strong {
  font-size: 16px;
  font-weight: 650;
}

.dashboard-content .priority-copy > span {
  font-size: 13px;
  color: var(--ui-muted);
  line-height: 1.6;
}

.dashboard-content .priority-copy b {
  font-weight: 650;
  color: var(--ui-text);
}

.dashboard-content .priority-action {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: none;
  font-size: 13px;
  font-weight: 600;
  color: var(--ui-accent);
}

.dashboard-content .recent-extractions .extraction-row {
  min-height: 64px;
  padding: 10px 18px;
}

.dashboard-content .recent-extractions .extraction-row strong {
  font-size: 14px;
  line-height: 1.6;
}

.dashboard-content .recent-extractions .extraction-row small {
  font-size: 12px;
}

.dashboard-content .dashboard-library {
  margin-bottom: 20px;
}

.dashboard-content .dashboard-library .panel-heading {
  min-height: 54px;
}

.dashboard-content .dashboard-library .collection-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.dashboard-content .dashboard-library .collection-row {
  border-bottom: 1px solid var(--ui-line);
  min-height: 55px;
  padding: 12px 18px;
}

.dashboard-content .dashboard-library .collection-row:nth-child(odd) {
  border-right: 1px solid var(--ui-line);
}

.dashboard-content .dashboard-library .collection-caption {
  padding: 10px 18px;
  font-size: 12px;
  color: var(--ui-muted);
}

.dashboard-content .dashboard-fold {
  margin: 0 0 12px;
  background: var(--ui-paper);
  border: 1px solid var(--ui-line);
  border-radius: 12px;
  overflow: hidden;
}

.dashboard-content .dashboard-fold > summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 68px;
  padding: 16px 18px;
  list-style: none;
  cursor: pointer;
}

.dashboard-content .dashboard-fold > summary::-webkit-details-marker {
  display: none;
}

.dashboard-content .dashboard-fold > summary > span {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dashboard-content .dashboard-fold > summary strong {
  font-size: 15px;
  font-weight: 650;
  color: var(--ui-ink);
}

.dashboard-content .dashboard-fold > summary small {
  font-size: 12px;
  color: var(--ui-muted);
}

.dashboard-content .dashboard-fold > summary > i {
  font-size: 12px;
  color: var(--ui-muted);
}

.dashboard-content .dashboard-fold[open] > summary {
  border-bottom: 1px solid var(--ui-line);
}

.dashboard-content .dashboard-fold[open] > summary > i {
  transform: rotate(180deg);
}

.dashboard-content .dashboard-fold .dashboard-main-grid {
  margin: 0;
  gap: 0;
}

.dashboard-content .dashboard-fold :is(.corpus-progress, .qa-status, .deliverable-status) {
  border: 0;
  border-radius: 0;
  margin: 0;
}

.dashboard-content .dashboard-fold .qa-status {
  border-left: 1px solid var(--ui-line);
}

.dashboard-content .dashboard-fold .quality-reference {
  border-width: 1px 0 0;
  border-radius: 0;
  margin: 0;
}

.dashboard-content .history-filters {
  gap: 12px;
}

.dashboard-content .history-workspace .history-filters {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(140px, 190px) auto auto;
  align-items: end;
  width: 100%;
  gap: 12px;
}

.dashboard-content .history-workspace .history-toolbar {
  display: block;
  padding: 18px 20px;
}

.dashboard-content .history-workspace .history-total {
  padding-top: 12px;
}

.dashboard-content .history-advanced {
  position: relative;
  min-width: 130px;
}

.dashboard-content .history-advanced > summary {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 8px 12px;
  list-style: none;
  border: 1px solid var(--ui-control);
  border-radius: 8px;
  background: var(--ui-paper);
  font-size: 13px;
  cursor: pointer;
}

.dashboard-content .history-advanced > summary::-webkit-details-marker {
  display: none;
}

.dashboard-content .history-advanced > summary > i {
  margin-left: auto;
  font-size: 11px;
}

.dashboard-content .filter-mark {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--ui-accent);
}

.dashboard-content .history-advanced[open] {
  grid-column: 1/-1;
  display: grid;
  grid-template-columns: 160px minmax(0, 1fr);
  align-items: start;
  gap: 16px;
}

.dashboard-content .history-advanced-fields {
  display: grid;
  grid-template-columns: minmax(140px, 0.6fr) minmax(0, 1.4fr);
  gap: 16px;
  align-items: end;
}

.dashboard-content .history-workspace .history-dates {
  grid-column: auto;
}

.dashboard-content .history-filter-actions {
  justify-content: flex-end;
}

@media (max-width: 1250px) {
  .dashboard-content .dashboard-fold .qa-status {
    border-left: 0;
    border-top: 1px solid var(--ui-line);
  }
  .dashboard-content .history-workspace .history-filters {
    grid-template-columns: minmax(180px, 1fr) minmax(130px, 0.7fr) auto;
  }
  .dashboard-content .history-filter-actions {
    grid-column: 1/-1;
  }
  .dashboard-content .priority-action {
    font-size: 12px;
    gap: 6px;
  }
}
@media (max-width: 1100px) {
  .dashboard-launchpad {
    grid-template-columns: minmax(0, 1fr);
  }
  .dashboard-content .priority-row {
    min-height: 82px;
  }
}
@media (max-width: 600px) {
  .dashboard-launchpad {
    gap: 16px;
    margin-bottom: 16px;
  }
  .dashboard-content .priority-row {
    flex-wrap: wrap;
    padding: 16px;
    gap: 10px;
  }
  .dashboard-content .priority-action {
    margin-left: 36px;
    flex-basis: calc(100% - 36px);
    font-size: 13px;
  }
  .dashboard-content .priority-copy > strong {
    font-size: 15px;
  }
  .dashboard-content .priority-complete {
    display: block;
  }
  .dashboard-content .dashboard-library .collection-list {
    grid-template-columns: 1fr;
  }
  .dashboard-content .dashboard-library .collection-row:nth-child(odd) {
    border-right: 0;
  }
  .dashboard-content .history-workspace .history-filters {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .dashboard-content .history-target {
    grid-column: 1/-1;
  }
  .dashboard-content .history-advanced[open] {
    grid-template-columns: 1fr;
  }
  .dashboard-content .history-advanced-fields {
    grid-template-columns: 1fr;
  }
  .dashboard-content .history-workspace .history-dates {
    grid-column: 1;
  }
  .dashboard-content .history-filter-actions {
    justify-content: flex-start;
  }
  .dashboard-content .history-advanced > summary {
    min-height: 44px;
  }
}
/* Same workspace: personal work first, recent runs beside it. */
.dashboard-content .recent-work {
  min-width: 0;
  margin: 0;
  border: 1px solid var(--ui-line);
  border-radius: 12px;
  background: var(--ui-paper);
  overflow: hidden;
}

.dashboard-content .recent-work .panel-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 58px;
  padding: 15px 18px;
  border-bottom: 1px solid var(--ui-line);
}

.dashboard-content .recent-work .panel-heading h2 {
  font-size: 16px;
  color: var(--ui-ink);
}

.dashboard-content .recent-work-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 66px;
  padding: 12px 18px;
  border-bottom: 1px solid var(--ui-line);
}

.dashboard-content .recent-work-row:last-of-type {
  border-bottom: 0;
}

.dashboard-content .recent-work-row.clickable-row:hover {
  background: var(--ui-hover);
}

.dashboard-content .recent-work-copy {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.dashboard-content .recent-work-name {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.6;
  overflow-wrap: anywhere;
  color: var(--ui-ink);
}

.dashboard-content .recent-work-copy > span, .dashboard-content .recent-work-copy > small {
  font-size: 12px;
  line-height: 1.5;
  color: var(--ui-muted);
}

.dashboard-content .recent-work-status {
  flex: none;
  font-size: 12px;
  color: var(--ui-muted);
  font-weight: 550;
}

.dashboard-content .recent-work-status[data-status=SUCCESS] {
  color: var(--ui-success);
}

.dashboard-content .recent-work-status[data-status=FAILED] {
  color: var(--ui-danger);
}

.dashboard-content .recent-work-status[data-status=RUNNING] {
  color: var(--ui-accent);
}

.dashboard-content .recent-work-row > i {
  font-size: 10px;
  color: var(--ui-muted);
}

.dashboard-content .extraction-reference .recent-extractions {
  border: 0;
  border-radius: 0;
  margin: 0;
}

.dashboard-content .extraction-reference .recent-extractions .panel-heading {
  min-height: 42px;
  justify-content: flex-end;
  border: 0;
  padding: 8px 18px;
}

.dashboard-content .extraction-reference .recent-extractions .panel-heading h2 {
  display: none;
}

.dashboard-content .history-phase-tabs {
  display: flex;
  gap: 4px;
  padding: 10px 14px;
  border-bottom: 1px solid var(--ui-line);
  background: var(--ui-soft);
  flex-wrap: wrap;
}

.dashboard-content .history-phase-tabs button {
  min-height: 42px;
  padding: 9px 16px;
  border: 0;
  border-radius: 8px;
  color: var(--ui-text);
  background: transparent;
  font-size: 14px;
  font-weight: 550;
  cursor: pointer;
}

.dashboard-content .history-phase-tabs button:hover:not(:disabled) {
  background: var(--ui-hover);
}

.dashboard-content .history-phase-tabs button.active {
  color: var(--ui-on-navy);
  background: var(--ui-accent);
}

.dashboard-content .history-phase-tabs button:focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 2px;
}

.dashboard-content .history-phase-tabs button:disabled {
  cursor: wait;
  opacity: 0.7;
}

.dashboard-content .history-workspace .history-filters {
  grid-template-columns: minmax(200px, 1fr) auto auto;
  max-width: none;
}

.dashboard-content .history-advanced-fields {
  grid-template-columns: minmax(120px, 0.6fr) minmax(120px, 0.6fr) minmax(0, 1.4fr);
}

@media (max-width: 700px) {
  .dashboard-content .history-workspace .history-filters {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .dashboard-content .history-workspace .history-target {
    grid-column: 1/-1;
  }
  .dashboard-content .history-workspace .history-advanced {
    grid-column: 1;
    min-width: 0;
  }
  .dashboard-content .history-workspace .history-filter-actions {
    grid-column: 2;
  }
  .dashboard-content .history-advanced[open] {
    grid-column: 1/-1;
    grid-template-columns: minmax(0, 1fr);
  }
  .dashboard-content .history-advanced-fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .dashboard-content .history-workspace .history-dates {
    grid-column: 1/-1;
  }
  .dashboard-content .history-phase-tabs {
    padding: 8px;
    gap: 2px;
  }
  .dashboard-content .history-phase-tabs button {
    min-height: 44px;
    padding: 9px 12px;
    flex: 1;
  }
  .dashboard-content .recent-work-row {
    padding: 12px 16px;
  }
}
/* The reviewer home contains only assigned QA and personal preference work. */
.reviewer-home {
  max-width: 1000px;
  margin-top: 12px;
}

.reviewer-intro {
  margin-bottom: 20px;
}
.reviewer-intro h2 {
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 6px;
}
.reviewer-intro p {
  margin: 0;
  color: var(--ui-muted);
  font-size: 14px;
  line-height: 1.6;
}

.reviewer-tasks {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.reviewer-task {
  display: flex;
  flex-direction: column;
  padding: 24px;
  border: 1px solid var(--ui-line);
  border-radius: 16px;
  background: var(--ui-paper);
}
.reviewer-task .reviewer-task-heading {
  display: flex;
  align-items: center;
  gap: 12px;
}
.reviewer-task .reviewer-task-heading h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
}
.reviewer-task .reviewer-total {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin: 24px 0 18px;
  font-variant-numeric: tabular-nums;
}
.reviewer-task .reviewer-total strong {
  font-size: 36px;
  line-height: 1.15;
  letter-spacing: -1px;
}
.reviewer-task .reviewer-total span {
  color: var(--ui-muted);
  font-size: 14px;
}
.reviewer-task .reviewer-counts {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
  margin: 0;
  padding: 16px 0;
  border-top: 1px solid var(--ui-line);
}
.reviewer-task .reviewer-counts div {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.reviewer-task .reviewer-counts dt {
  color: var(--ui-muted);
  font-size: 13px;
}
.reviewer-task .reviewer-counts dd {
  margin: 0;
  font-weight: 650;
  font-size: 19px;
  font-variant-numeric: tabular-nums;
}
.reviewer-task .reviewer-note {
  font-size: 13px;
  line-height: 1.6;
  color: var(--ui-muted);
  margin: 0 0 20px;
  flex: 1;
}
.reviewer-task .button {
  align-self: flex-start;
  min-height: 42px;
}

@media (max-width: 650px) {
  .reviewer-tasks {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .reviewer-task {
    padding: 20px;
  }
}
/* Long selected labels keep their full text next to the shared chevron. */
@media (max-width: 700px) {
  .dashboard-content .history-workspace .history-advanced[open] {
    width: 100%;
    justify-self: stretch;
  }
  .dashboard-content .history-workspace .history-advanced[open] .history-advanced-fields {
    grid-template-columns: minmax(0, 1fr);
  }
}`],
})
export class PageDashboardComponent implements OnInit, OnDestroy {
    openRow(event:MouseEvent) { activateListRow(event); }
    data: any = null; loading = true; refreshing = false; error = ''; csrf = '';
    collections: any[] = []; activeWork = ''; historyOpen = false;
    historyData: any = null; historyBusy = false; historyError = '';
    historyType = ''; historyStatus = ''; historyPhase = '';
    readonly historyPhases = [{id:'',label:'전체'}, {id:'ACTIVE',label:'진행 중'}, {id:'ATTENTION',label:'확인 필요'}, {id:'DONE',label:'완료'}]; historyQuery = ''; historyFrom = ''; historyTo = '';
    private appliedHistory = {type:'',status:'',phase:'',q:'',date_from:'',date_to:''};
    workspacePage = '홈'; sessionUser: any = null;
    today = new Intl.DateTimeFormat('ko-KR', {year:'numeric',month:'long',day:'numeric',weekday:'long',timeZone:'Asia/Seoul'}).format(new Date());
    lastRefreshedAt: Date | null = null;
    updating = false; snapshotStale = false;
    private pollTimer: any; private pollStartedAt: number | null = null; private pollAttempts = 0;
    private overviewTimeout: any; private initialNavigationPending = false;
    private visibilityHandler = () => {
        if (document.hidden) this.clearPollTimer();
        else if (this.updating && !this.dead && !this.refreshing) this.schedulePoll(0);
    };
    private fragmentSub: any; private fragment: string | null = null;
    get canAuthor() { const user=this.data?.user||this.sessionUser; return user?.status==='active' && ['admin','researcher'].includes(user.role); }
    get canManage() { const user=this.data?.user||this.sessionUser; return user?.status==='active' && user.role==='admin'; }
    get isReviewer() { return (this.data?.user||this.sessionUser)?.role === 'reviewer'; }
    get historyView() { return this.fragment === 'jobs' && !this.isReviewer; }
    private dead = false;
    private overviewRequest: AbortController | null = null;
    private initialOverview: Promise<any> | null = null;
    private cancelInitialOverview: (() => void) | null = null;
    constructor(@Inject( Service) public service: Service,@Inject( ActivatedRoute)  private route: ActivatedRoute) {
        this.fragment = this.route.snapshot.fragment || null;
        this.workspacePage = this.historyView ? '작업 현황' : '홈';
        const prepared = this.route.snapshot.data['workspace'];
        this.initialOverview = prepared?.initialOverview || null;
        this.cancelInitialOverview = prepared?.cancelInitialOverview || null;
        this.sessionUser = prepared?.session?.data?.user;
        this.csrf = prepared?.session?.data?.csrf || '';
        this.workspacePage = this.historyView ? '작업 현황' : '홈';
        if (prepared?.result?.code === 200) this.applyOverview(prepared.result.data);
        else if (!prepared?.deferred) this.error = '데이터를 불러오지 못했습니다. 다시 시도해 주세요.';
        this.loading = !!prepared?.deferred;
        this.initialNavigationPending = this.loading;
    }
    private scope(user: any) { return [user?.id, user?.role, user?.status].join(':'); }
    private clearPollTimer() { clearTimeout(this.pollTimer); this.pollTimer = null; }
    private stopPolling() {
        this.clearPollTimer(); this.updating = false; this.pollStartedAt = null; this.pollAttempts = 0;
    }
    private clearOverview() {
        this.stopPolling(); this.data = null; this.collections = []; this.lastRefreshedAt = null;
        this.activeWork = ''; this.historyData = null; this.historyOpen = false; this.historyBusy = false;
        this.historyError = ''; this.historyType = ''; this.historyStatus = ''; this.historyPhase = ''; this.historyQuery = ''; this.historyFrom = ''; this.historyTo = '';
        this.appliedHistory = {type:'',status:'',phase:'',q:'',date_from:'',date_to:''}; this.snapshotStale = false;
    }
    private acceptUser(user: any) {
        if (!user) return;
        if (this.sessionUser && this.scope(user) !== this.scope(this.sessionUser)) this.clearOverview();
        this.sessionUser = user;
    }
    private applySnapshot(snapshot: any) {
        this.snapshotStale = !!snapshot?.stale;
        this.updating = !!snapshot?.refresh_pending && !snapshot?.refresh_failed;
        if (!this.updating) this.stopPolling();
        if (snapshot?.refresh_failed) this.error = this.data
            ? '갱신하지 못했습니다. 마지막 집계를 표시합니다. 새로고침을 다시 시도해 주세요.'
            : '집계를 준비하지 못했습니다. 새로고침을 다시 시도해 주세요.';
    }
    applyOverview(data: any) {
        this.acceptUser(data.user);
        const asOf = data.snapshot?.as_of;
        const unchanged = !!asOf && this.data?.snapshot?.as_of === asOf;
        if (unchanged) {
            // The global snapshot is unchanged; personal review/history fields remain fresh.
            this.data = {...data, folders: this.data.folders, corpus_progress: this.data.corpus_progress,
                work: {...data.work, recent: this.data.work?.recent}};
        } else {
            this.data = data;
            this.collections = [...(data.folders || [])].sort((a, b) => a.root.localeCompare(b.root) || a.name.localeCompare(b.name, 'ko'));
        }
        if (!unchanged) {
            const stamp = data.snapshot ? (asOf ? new Date(asOf) : null) : new Date();
            this.lastRefreshedAt = stamp && !isNaN(stamp.getTime()) ? stamp : null;
        }
        this.applySnapshot(data.snapshot);
    }
    snapshotTime() {
        if (!this.lastRefreshedAt) return '';
        const now = new Date();
        const koreaDay = new Intl.DateTimeFormat('en-CA', {year:'numeric',month:'2-digit',day:'2-digit',timeZone:'Asia/Seoul'});
        const sameDay = koreaDay.format(this.lastRefreshedAt) === koreaDay.format(now);
        return new Intl.DateTimeFormat('ko-KR', {
            ...(sameDay ? {} : {year:'numeric', month:'2-digit', day:'2-digit'} as const),
            hour:'2-digit', minute:'2-digit', second:'2-digit', hour12:false, timeZone:'Asia/Seoul'
        }).format(this.lastRefreshedAt);
    }
    private pollingExpired() {
        return this.pollAttempts >= 30 || (this.pollStartedAt !== null && Date.now() - this.pollStartedAt >= 60000);
    }
    private pauseDelayedRefresh() {
        this.stopPolling(); this.loading = false;
        this.error = this.data
            ? '집계가 지연되고 있습니다. 마지막 집계를 표시합니다. 새로고침으로 다시 확인해 주세요.'
            : '집계가 지연되고 있습니다. 새로고침으로 다시 확인해 주세요.';
        this.service.render();
    }
    private schedulePoll(delay = 2000) {
        this.clearPollTimer();
        if (this.dead || !this.updating) return;
        if (this.pollStartedAt === null) this.pollStartedAt = Date.now();
        if (this.pollingExpired()) { this.pauseDelayedRefresh(); return; }
        if (document.hidden) return;
        const wait = delay === 0 ? 0 : Math.min(5000, Math.max(1500, Number(delay) || 2000));
        this.pollTimer = setTimeout(() => {
            this.pollTimer = null;
            if (this.dead || !this.updating || document.hidden) return;
            if (this.pollingExpired()) { this.pauseDelayedRefresh(); return; }
            void this.load(false, true);
        }, Math.min(wait, 60000 - (Date.now() - this.pollStartedAt)));
    }
    async ngOnInit() {
        await this.service.init();
        if (this.dead) return;
        document.title = this.workspacePage + ' · 한의문헌 저작도구';
        document.addEventListener('visibilitychange', this.visibilityHandler);
        this.fragmentSub = this.route.fragment.subscribe(fragment => {
            this.fragment = fragment;
            this.workspacePage = this.historyView ? '작업 현황' : '홈';
            document.title = this.workspacePage + ' · 한의문헌 저작도구';
            if (!this.historyView) this.historyOpen = false;
            this.service.render();
            if (!this.loading) this.scroll(fragment === 'jobs' ? 'jobs' : 'dashboard-top');
        });
        if (this.loading) await this.load(false);
        else if (this.updating) this.schedulePoll(this.data?.snapshot?.retry_after_ms);
    }
    ngOnDestroy() {
        this.dead = true;
        this.fragmentSub?.unsubscribe();
        document.removeEventListener('visibilitychange', this.visibilityHandler);
        this.stopPolling(); clearTimeout(this.overviewTimeout);
        this.overviewRequest?.abort(); this.overviewRequest = null;
        this.cancelInitialOverview?.(); this.initialOverview = null; this.cancelInitialOverview = null;
    }
    afterLogout() {
        this.ngOnDestroy(); this.clearOverview(); this.sessionUser = null; this.csrf = '';
        this.error = ''; this.loading = false; this.refreshing = false;
    }
    async load(refreshSession = true, check = false) {
        if (this.dead || this.refreshing) return;
        this.clearPollTimer();
        if (check && this.pollingExpired()) { this.pauseDelayedRefresh(); return; }
        if (check) this.pollAttempts++;
        else { this.pollStartedAt = null; this.pollAttempts = 0; }
        this.refreshing = true; this.error = '';
        const controller = new AbortController();
        this.overviewRequest = controller;
        const initial = !refreshSession && !check ? this.initialOverview : null;
        if (!initial && this.initialOverview) {
            this.cancelInitialOverview?.();
            this.initialOverview = null; this.cancelInitialOverview = null;
        }
        const cancelInitial = initial ? this.cancelInitialOverview : null;
        if (initial) {
            this.initialOverview = null;
            if (cancelInitial) controller.signal.addEventListener('abort', cancelInitial, {once: true});
        }
        const timer = setTimeout(() => controller.abort(), 45000);
        this.overviewTimeout = timer;
        let retryAfter = 2000;
        const read = async (app: string, action: string, values: any = {}) => {
            const body = new FormData();
            for (const [key, value] of Object.entries(values)) body.append(key, String(value));
            const response = await fetch('/wiz/api/' + app + '/' + action, {
                method: 'POST', body, signal: controller.signal
            });
            return response.json();
        };
        try {
            await this.service.render();
            if (this.dead) return;
            const [session, res] = await Promise.all([
                refreshSession ? read('page.access', 'bootstrap') : Promise.resolve(null),
                initial || read('page.dashboard', 'overview', check ? {check: 1} : refreshSession ? {refresh: 1} : {})
            ]);
            if (this.dead) return;
            if (session?.code === 401 || (session?.code === 200 && !session.data?.user) || res.code === 401) {
                this.clearOverview(); this.sessionUser = null;
                this.service.href('/access/login'); return;
            }
            if (session?.code === 200) {
                this.csrf = session.data.csrf;
                this.acceptUser(session.data.user);
                if (res.data?.user && this.scope(res.data.user) !== this.scope(session.data.user)) {
                    this.clearOverview();
                    this.error = '계정 정보가 변경되었습니다. 새로고침으로 다시 확인해 주세요.';
                    return;
                }
            }
            if (res.code !== 200 && res.code !== 202) throw new Error();
            if (initial && res.data?.user && this.scope(res.data.user) !== this.scope(this.sessionUser)) throw new Error();
            this.acceptUser(res.data?.user);
            retryAfter = res.data?.snapshot?.retry_after_ms || 2000;
            if (res.code === 202) {
                this.applySnapshot(res.data?.snapshot);
            } else {
                this.applyOverview(res.data);
                if (!check) {
                    if (this.historyOpen) await this.loadHistory(this.historyData?.page || 1, true);
                    else this.historyData = null;
                }
            }
        } catch {
            if (this.dead) return;
            this.stopPolling();
            this.error = this.data
                ? '갱신하지 못했습니다. 마지막으로 불러온 정보를 표시합니다. 새로고침을 다시 시도해 주세요.'
                : '데이터를 불러오지 못했습니다. 새로고침을 다시 시도해 주세요.';
        } finally {
            clearTimeout(timer);
            if (cancelInitial) controller.signal.removeEventListener('abort', cancelInitial);
            if (initial && this.cancelInitialOverview === cancelInitial) this.cancelInitialOverview = null;
            if (this.overviewRequest === controller) {
                this.overviewRequest = null; this.overviewTimeout = null;
            }
            if (!this.dead) {
                this.loading = !this.data && this.updating;
                this.refreshing = false;
                await this.service.render();
                if (this.initialNavigationPending && this.data && !this.loading) {
                    this.initialNavigationPending = false;
                    if (this.fragment === 'jobs') await this.scroll('jobs');
                }
                if (this.updating) this.schedulePoll(retryAfter);
            }
        }
    }
    async refreshPage() {
        if (this.historyView && this.data && !this.data.pending && !this.data.restricted && !this.data.assigned_only) {
            await this.loadHistory(this.historyData?.page || 1, true);
        } else {
            await this.load();
            if (this.historyView && this.data && !this.data.pending && !this.data.restricted && !this.historyData && !this.historyBusy) {
                await this.scroll('jobs');
            }
        }
    }
    async toggleHistory(event: Event) {
        this.historyOpen = (event.target as HTMLDetailsElement).open;
        if (this.historyOpen && !this.historyData && !this.data?.assigned_only) await this.loadHistory();
    }
    get historyFiltered() { return !!(this.historyPhase || this.historyType || this.historyStatus || this.historyQuery.trim() || this.historyFrom || this.historyTo); }
    preferenceParams() {
        const progress = this.data?.preference_progress;
        return progress?.pending ? {start:'1'} : progress?.total ? {view:'results'} : {};
    }
    async setHistoryPhase(phase:string) {
        if (this.historyBusy || !this.historyPhases.some(item => item.id===phase)) return;
        this.historyPhase=phase; this.historyStatus='';
        await this.loadHistory();
    }
    async resetHistoryFilters() {
        this.historyType=''; this.historyStatus=''; this.historyPhase=''; this.historyQuery=''; this.historyFrom=''; this.historyTo='';
        await this.loadHistory();
    }
    async loadHistory(page = 1, pagination = false) {
        if (this.dead || this.historyBusy || this.data?.assigned_only || this.isReviewer) return;
        const scope = this.scope(this.sessionUser);
        const filters = pagination ? {...this.appliedHistory} : {type:this.historyType,status:this.historyStatus,phase:this.historyPhase,q:this.historyQuery.trim(),date_from:this.historyFrom,date_to:this.historyTo};
        this.historyBusy = true; this.historyError = '';
        await this.service.render();
        try {
            const res = await wiz.call('history', {page, ...filters});
            if (this.dead || scope !== this.scope(this.sessionUser)) return;
            if (res.code === 401) { this.service.href('/access/login'); return; }
            if (res.code !== 200) throw new Error(res.data?.message || '이력을 불러오지 못했습니다. 다시 시도해 주세요.');
            const previous = this.historyData;
            this.historyData = res.data; this.appliedHistory = filters;
            this.historyType=filters.type; this.historyStatus=filters.status; this.historyPhase=filters.phase; this.historyQuery=filters.q; this.historyFrom=filters.date_from; this.historyTo=filters.date_to;
            if (!previous || previous.page !== res.data.page ||
                previous.type !== res.data.type || previous.phase !== res.data.phase || previous.status !== res.data.status ||
                previous.query !== res.data.query || previous.date_from !== res.data.date_from || previous.date_to !== res.data.date_to) {
                await this.service.render();
                const list = document.querySelector('.history-list') as HTMLElement | null;
                if (previous && this.historyView) {
                    list?.scrollIntoView({block: 'start', behavior: 'instant' as ScrollBehavior});
                    list?.focus({preventScroll: true});
                }
            }
        } catch (error:any) {
            if (this.dead || scope !== this.scope(this.sessionUser)) return;
            this.historyError = (error?.message || '작업 현황을 불러오지 못했습니다. 다시 시도해 주세요.') +
                (this.historyData ? ' 이전 조회 결과를 표시합니다.' : '');
        } finally {
            if (!this.dead && scope === this.scope(this.sessionUser)) {
                this.historyBusy = false;
                await this.service.render();
            }
        }
    }
    historyRange() {
        const data = this.historyData;
        if (!data?.total) return '0건';
        const first = (data.page - 1) * data.page_size + 1;
        return first + '–' + Math.min(data.page * data.page_size, data.total) + ' / ' + data.total.toLocaleString() + '건';
    }
    corpusQuality(folder:string) { return this.data?.work?.corpus_quality?.find(item=>item.folder===folder); }
    visibleCollections() { return this.activeWork ? this.collections.filter(item => item.work?.[this.activeWork] > 0) : this.collections; }
    async setWork(value:string) {
        this.activeWork=value;
        await this.service.render();
        if (this.dead || this.historyView) return;
        const target=document.getElementById('sources');
        target?.scrollIntoView({block:'start',behavior:'instant' as ScrollBehavior});
        target?.focus({preventScroll:true});
    }
    resultParams(item:any) { return {path:item.key.split('/').slice(0,-1).join('/'),result:item.key,job:item.job}; }
    decisionLabel(code: string) { return {USE:'사용',HOLD:'보류',EXCLUDE:'제외'}[code] || '미판정'; }
    count(status: string) { return this.data?.distribution?.find((x: any) => x.status === status)?.count || 0; }
    percent(status: string) { return this.data?.counts?.qa ? this.count(status) / this.data.counts.qa * 100 : 0; }
    label(status: string) {
        return {REVIEW:'검토 중',APPROVED:'사용 중',DRAFT:'등록',RETIRED:'사용 종료',PENDING:'대기',
            RUNNING:'실행 중',NEEDS_ATTENTION:'확인 필요',CANCELLING:'취소 중',CANCELLED:'취소됨',PAUSING:'중단 중',PAUSED:'중단됨',SUCCESS:'완료',FAILED:'실패',REVISION_REQUIRED:'수정 필요',REJECTED:'반려'}[status] || status;
    }
    jobLabel(type: string) {
        if (type === 'KG_EXTRACT') return '지식 후보 추출';
        if (/DPO/i.test(type)) return '선호도 데이터 생성';
        if (/QA|GOLD/i.test(type)) return 'QA 데이터 생성';
        if (/OCR|EXTRACT/i.test(type)) return '문헌 추출';
        if (/EVAL/i.test(type)) return '평가 실행';
        return type || '데이터 처리';
    }
    date(value: string) {
        return formatWorkspaceDate(value);
    }
    async scroll(id: string) {
        if (this.dead) return;
        if (this.isReviewer && id === 'jobs') id = 'dashboard-top';
        if (this.loading && id === 'jobs') { this.fragment = 'jobs'; return; }
        if (id === 'jobs') {
            this.historyOpen = true;
            await this.service.render();
            if (!this.historyData && !this.data?.assigned_only) await this.loadHistory();
        }
        if (this.dead) return;
        const target = id ? document.getElementById(id) : null;
        const behavior = 'instant' as ScrollBehavior;
        if (id === 'dashboard-top' || (id === 'jobs' && this.historyView)) window.scrollTo({top: 0, behavior});
        else target?.scrollIntoView({behavior});
        if (id === 'jobs') target?.focus({preventScroll: true});
        this.service.render();
    }
}

export default PageDashboardComponent;